module.exports = __webpack_public_path__ + "static/media/worship.2c6b8e8a.svg";